import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoaderService } from "../service/loader.service";
import { Message } from "../service/message.service";
import { RestService } from "../service/rest.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styles: [],
  standalone: false,
})
export class ChangePasswordComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message
  ) {}

  email: string = "";
  showPassword = false;
  password = "";
  confirmPassword = "";
  token = "";
  app = "";
  acceptTerms = true;

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const token = params.get("token");
    const app = params.get("app");
    if (token && app) {
      this.app = app;
      this.token = token;
    } else {
      this.message.showMessage("Link reset password invalido", "error");
      this.backToLogin();
    }
  }

  checkboxTerms(event: any) {
    this.acceptTerms = event.checked;
  }

  backToLogin() {
   window.location.replace('login')
  }
  changePassword() {
    if (this.password == this.confirmPassword) {
      this.loader.on();
      this.rest
        .post("/auth/recovery-password/" + this.token, {
          password: this.password,
        })
        .subscribe({
          next: () => {
            this.loader.off(true);
            this.message.showMessage(
              this.app == "0"
                ? "Password cambiata con successo"
                : "Password cambiata con successo ora puoi tornare all'app",
              "success",
              "message-fix-index"
            );
              this.backToLogin();
          },
          error: (error:any) => {
            this.loader.off(true);
            this.message.showMessage(
              error.error.message,
              "error",
              "message-fix-index"
            );
          },
        });
    } else {
      this.message.showMessage(
        "Password e conferma password devono essere uguali",
        "error",
        "message-fix-index"
      );
    }
  }

  checkPassword(password:string) {
  if (password.length < 8) 
    return "La password deve contenere almeno 8 caratteri.";
  
  if (!/[A-Z]/.test(password)) 
    return "La password deve contenere almeno una lettera maiuscola.";
  
  if (!/[a-z]/.test(password)) 
    return "La password deve contenere almeno una lettera minuscola.";
  
  if (!/[0-9]/.test(password)) 
    return "La password deve contenere almeno un numero.";
  
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/.test(password)) 
    return "La password deve contenere almeno un carattere speciale.";
  
  return "✅ La password è sicura!";
}
}
